const PREFIX = 'itt';

// Supported modules
export const MODULES = {
  USER: 'user'
};

const localStorage = {
  // Set entire module data
  setModule(module, data) {
    const fullKey = `${PREFIX}:${module}`;
    const existing = this.getModule(module);
    const merged =
      existing && typeof existing === 'object' && typeof data === 'object'
        ? { ...existing, ...data }
        : data;
    const serializedValue = JSON.stringify(merged);
    window.localStorage.setItem(fullKey, serializedValue);
  },

  // Get entire module data
  getModule(module) {
    const fullKey = `${PREFIX}:${module}`;
    const serializedValue = window.localStorage.getItem(fullKey);
    if (serializedValue === null) {
      return null;
    }
    try {
      return JSON.parse(serializedValue);
    } catch (error) {
      return null;
    }
  },

  clearModule(module) {
    // Clear both old format (module:key) and new format (module)
    const fullKey = `${PREFIX}:${module}`;
    window.localStorage.removeItem(fullKey);

    const modulePrefix = `${PREFIX}:${module}:`;
    const keys = Object.keys(window.localStorage);
    keys.forEach(key => {
      if (key.startsWith(modulePrefix)) {
        window.localStorage.removeItem(key);
      }
    });
  }
};

export default localStorage;
